import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { config } from '../../../config';
import { setLinkedInState } from '../../../core/actions';

import {
  FacebookButton,
  GoogleButton,
  LinkedInButton,
} from '../../../core/components/social-button';

import {
  Container,
  CreateAccount,
  Loader,
  Logo,
  Muted,
  Segment,
  SignContainer,
  Title,
} from './styles';

import withGa from '../../../core/components/with-ga';

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uri: null,
      loading: true,
    };
  }

  componentDidMount() {
    const state = Math.random()
      .toString(36)
      .slice(2);
    const uri = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${
        config.REACT_APP_LINKEDIN_CLIENT_ID
      }&redirect_uri=${config.REACT_APP_LINKEDIN_REDIRECT_URI}&state=${state}&scope=${
        config.REACT_APP_LINKEDIN_SCOPE
      }`;

    this.setState({ uri });
    this.props.setLinkedInState(state);

    const interval = setInterval(() => {
      if (document.getElementById('pinc.helper') !== null) {
        this.setState({ loading: false }, () => clearInterval(interval));
      }
    }, 250);
  }

  render() {
    const { uri, loading } = this.state;

    return (
      <Container>
        <Logo src="/images/playbook-logo.png" alt="Playbook" />

        <Segment>
          <SignContainer>
            <Title>
              Participant Sign In
            </Title>

            <div style={{ display: 'none' }} id="pathfix" />

            {loading ? (
              <Loader data-loader="sign-in-loader" />
            ) : (
              <>
                <FacebookButton />
                <GoogleButton />
                <LinkedInButton href={encodeURI(uri)} />
              </>
            )}

            <CreateAccount fontSize="15px">
              New to PlaybookUX?
              {' '}
              <Link to="/sign-up">Create account</Link>
            </CreateAccount>
          </SignContainer>

          <Muted>
            By using Playbook you agree to the
            {' '}
            <a target="_blank" rel="noopener noreferrer" href="https://www.playbookux.com/terms-conditions/">
              Terms & Conditions
            </a>
            {' '}
            and
            {' '}
            <a target="_blank" rel="noopener noreferrer" href="https://www.playbookux.com/privacy-policy/">
              Privacy Policy
            </a>
            .
            You can modify your email and SMS notifications in your settings.
          </Muted>
        </Segment>
      </Container>
    );
  }
}

SignIn.propTypes = {
  setLinkedInState: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setLinkedInState,
}, dispatch);

export default compose(
  connect(null, mapDispatchToProps),
  withGa,
)(SignIn);
